import React from 'react';
import { NavLink, Redirect, Switch, useRouteMatch } from 'react-router-dom';
import Inventory from './Inventory';
import Vendors from './Vendors';
import Authorized from 'routes/authorized';
import { useSelectAuthorization } from 'store';
import { PermissionType as P } from 'lib/util';
import classes from './index.module.scss';

/**
 * Inventories screen component
 * Provides a tabbed interface for managing inventory items and vendors
 * Each tab is protected by permission checks
 */
const InventoriesScreen = () => {
	// Route matching for nested routes
	const { url, path } = useRouteMatch();
	// Permission checks for inventory and vendor management
	const { canListInventory, canListVendor } = useSelectAuthorization();

	return (
		<>
			<div className={classes['inventories']}>
				{/* Navigation tabs - only shown if user has appropriate permissions */}
				<div className={classes['tabs']}>
					{/* Inventory tab - only visible if user can list inventory */}
					{canListInventory && (
						<NavLink to={`${url}/home`} className={classes['tab']} activeClassName={classes['active-tab']}>
							Inventory
						</NavLink>
					)}
					{/* Vendors tab - only visible if user can list vendors */}
					{canListVendor && (
						<NavLink
							to={`${url}/vendors`}
							className={classes['tab']}
							activeClassName={classes['active-tab']}
						>
							Vendors
						</NavLink>
					)}
				</div>
				{/* Tab content area - renders the component for the selected tab */}
				<div className={classes['tab-content']}>
					<Switch>
						{/* Each route is protected by permission checks */}
						<Authorized permission={P.LIST_INVENTORY} exact path={`${path}/home`} component={Inventory} />
						<Authorized permission={P.LIST_VENDOR} exact path={`${path}/vendors`} component={Vendors} />
						{/* Default redirect to inventory tab */}
						<Redirect from="/" to={`${url}/home`} />
					</Switch>
				</div>
			</div>
		</>
	);
};

export default InventoriesScreen;
